import { render } from "./PrivacyAndPolicy.vue?vue&type=template&id=3dd68d76"
import script from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__